var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowSmallUp = function SvgArrowSmallUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.60531 7.84831C9.85079 7.64805 10.2131 7.6626 10.4419 7.89144L13.7752 11.2248C14.0193 11.4688 14.0193 11.8645 13.7752 12.1086C13.5311 12.3526 13.1355 12.3526 12.8914 12.1086L10 9.21712L7.10856 12.1086C6.86448 12.3526 6.46885 12.3526 6.22477 12.1086C5.98069 11.8645 5.98069 11.4688 6.22477 11.2248L9.55811 7.89144L9.60531 7.84831Z",
    fill: "currentColor"
  })));
};
export default SvgArrowSmallUp;